import { useTranslation } from 'react-i18next';

import type { FeedbackStatus } from '@/entities/feedback';

import { statusLabel } from './labels';
import { StatusIcon } from './StatusIcon';
import styles from './StatusBadge.module.css';

interface Props {
  status: FeedbackStatus;
  animated?: boolean;
  size?: 'sm' | 'lg';
}

/** The status icon immediately LEFT of the status name: icon + color + text always agree. */
export function StatusBadge({ status, animated = false, size = 'sm' }: Props) {
  const { t } = useTranslation();
  return (
    <span className={`${styles.badge} ${size === 'lg' ? styles.lg : ''}`} data-status={status}>
      <StatusIcon status={status} animated={animated} size={size === 'lg' ? 26 : 18} />
      <span className={styles.label}>{statusLabel(t, status)}</span>
    </span>
  );
}
